<app-question-template [form]="form" [question]="question">
	<div [id]="question.id">
		@if (isV2()) {
			@if (answer?.answers[0] != null) {
				<button
					type="button"
					class="action-panel"
					[attr.aria-label]="'CHECKLISTS__QUESTIONS__NUMBER__PLACEHOLDER' | transloco"
				>
					<span class="action-panel-value">
						{{ answer.answers[0] }}
						@if (unit?.symbol != null) {
							<span class="action-panel-unit">{{ unit.symbol }}</span>
						}
					</span>
				</button>
			} @else {
				<button type="button" class="action-panel">
					<span class="action-panel-label">
						{{ "CHECKLISTS__QUESTIONS__NUMBER__PLACEHOLDER" | transloco }}
					</span>
				</button>
			}
		} @else if (answer?.answers[0] != null) {
			<button
				type="button"
				class="current-answer"
				[attr.aria-label]="'CHECKLISTS__QUESTIONS__NUMBER__PLACEHOLDER' | transloco"
			>
				<div class="value">{{ answer.answers[0] }}</div>
				@if (unit?.symbol != null) {
					<div class="unit-suffix">{{ unit.symbol }}</div>
				}
			</button>
		} @else {
			<div class="button-container">
				<ion-button shape="round">
					{{ "CHECKLISTS__QUESTIONS__NUMBER__PLACEHOLDER" | transloco }}
				</ion-button>
			</div>
		}
	</div>

	<ion-modal
		#modal
		[trigger]="question.id"
		id="number-input"
		[class.number-input-modal-v2]="isV2()"
		[initialBreakpoint]="0.2"
		[breakpoints]="[0, 0.2]"
		handleBehavior="none"
		(ionModalDidPresent)="onModalDidPresent()"
		(ionModalDidDismiss)="onModalDismiss($event)"
	>
		<ng-template>
			<div class="number-input" [class.number-input-v2]="isV2()">
				<div class="number-input-title">{{ question.translatedText }}</div>

				<div class="input-container">
					<ion-item lines="none" class="ion-justify-content-center">
						<ion-input
							class="ion-text-right"
							[formControl]="numberFormControl"
							#number
							inputmode="decimal"
							placeholder="0"
							type="text"
							(keydown.enter)="accept()"
						>
							@if (unit?.symbol != null) {
								<ion-text class="suffix" slot="end">{{ unit.symbol }}</ion-text>
							}
						</ion-input>
					</ion-item>

					@if (isV2()) {
						@if (numberFormControl.dirty) {
							<button
								type="button"
								class="number-input-v2-action"
								(click)="accept()"
								[disabled]="numberFormControl.invalid"
							>
								<span
									class="material-symbols-outlined material-symbols-outlined--size-24"
									aria-hidden="true"
								>
									check
								</span>
							</button>
						} @else if (numberFormControl.value != null) {
							<button
								type="button"
								class="number-input-v2-action number-input-v2-action--danger"
								(click)="discard()"
							>
								<span
									class="material-symbols-outlined material-symbols-outlined--size-24"
									aria-hidden="true"
								>
									delete
								</span>
							</button>
						}
					} @else if (numberFormControl.dirty) {
						<ion-button
							class="button-icon"
							shape="round"
							(click)="accept()"
							[disabled]="numberFormControl.invalid"
						>
							<ion-icon slot="icon-only" name="checkmark-outline"></ion-icon>
						</ion-button>
					} @else if (numberFormControl.value != null) {
						<ion-button class="button-icon" shape="round" (click)="discard()" color="danger">
							<ion-icon slot="icon-only" name="trash-outline"></ion-icon>
						</ion-button>
					}
				</div>

				@if (numberFormControl.dirty && numberFormControl.errors != null) {
					<div class="invalid-input">
						@if (numberFormControl.errors["min"]) {
							<div>
								{{
									"CHECKLISTS__QUESTIONS__NUMBER__VALUE_OUT_OF_RANGE_MINIMUM"
										| transloco: { minimum: question.minimum }
								}}
							</div>
						}
						@if (numberFormControl.errors["max"]) {
							<div>
								{{
									"CHECKLISTS__QUESTIONS__NUMBER__VALUE_OUT_OF_RANGE_MAXIMUM"
										| transloco: { maximum: question.maximum }
								}}
							</div>
						}
						@if (numberFormControl.errors["minDecimalPlaces"]) {
							<div>
								{{
									"CHECKLISTS__QUESTIONS__NUMBER__DECIMAL_SCALE_MINIMUM_INVALID"
										| transloco: { minimum: question.decimalScale.minimum }
								}}
							</div>
						}
						@if (numberFormControl.errors["maxDecimalPlaces"]) {
							<div>
								{{
									"CHECKLISTS__QUESTIONS__NUMBER__DECIMAL_SCALE_MAXIMUM_INVALID"
										| transloco: { maximum: question.decimalScale.maximum }
								}}
							</div>
						}
					</div>
				}
			</div>
		</ng-template>
	</ion-modal>
</app-question-template>
